// composables/useLanguage.ts
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { Languages, LANGUAGE_CODES } from './useTranslations';

export const currentLanguage = ref<Languages>('en');

export function setLanguage(lang: Languages) {
  currentLanguage.value = lang;
}

export function getUrlLanguage(url: string): Languages {
  const language = url.split('/')[1] as Languages;
  if (LANGUAGE_CODES.includes(language)) {
    return language;
  }
  return 'en';
}

// Get localized path for current language
export function getLocalizedPath(path: string): string {
  const lang = currentLanguage.value;
  if (lang === 'en') return path;
  return `/${lang}${path.startsWith('/') ? path : '/' + path}`;
}

// This part must only be used inside setup() or components

export function useLanguage() {
  const router = useRouter();

  // Get current path for specific language
  function getPathForLanguage(lang: Languages): string {
    const currentPath = router.currentRoute.value.fullPath;
    const supportedLangs: Languages[] = ['en', 'de', 'es'];

    const url = new URL(currentPath, 'http://dummy'); // To safely parse
    const segments = url.pathname.split('/').filter(Boolean);

    // Remove the existing lang prefix if present
    if (segments.length && supportedLangs.includes(segments[0] as Languages)) {
      segments.shift();
    }

    // Prepend lang if it's not "en"
    const localizedSegments = lang === 'en' ? segments : [lang, ...segments];

    return '/' + localizedSegments.join('/');
  }

  return { getPathForLanguage };
}
